import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { VehicleMakeSearchDto } from '../../../shared/modules/vehicle-makes';
import { VehicleModelSearchDto } from '../../../shared/modules/vehicle-models';
import { LocationSearchDto } from '../../locations';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { VehicleCategorySearchDto } from '../../vehicle-categories';
import { VehicleColorListDto } from '../../vehicle-colors/dtos/vehicle-color-list.dto';

/**
 * Resolved related records for a vehicle activity event, keyed by relation.
 */
export class VehicleActivityEventHydration {
  make?: ActivityFieldHydration<VehicleMakeSearchDto>;
  model?: ActivityFieldHydration<VehicleModelSearchDto>;
  exteriorColor?: ActivityFieldHydration<VehicleColorListDto>;
  interiorColor?: ActivityFieldHydration<VehicleColorListDto>;
  supplier?: ActivityFieldHydration<SupplierSearchDto>;
  location?: ActivityFieldHydration<LocationSearchDto>;
  vehicleCategory?: ActivityFieldHydration<VehicleCategorySearchDto>;
  link?: ActivityLinkHydration;
}
